'use client'
import { useState } from 'react';
import NewsList from './NewsList';

const TabbedNewsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'featured' | 'new'>('featured');

  return (
    <div className="">
      <div className="flex space-x-4 border-b border-gray-200 mb-2 bg-white rounded justify-center shadow-sm">
        <button
          onClick={() => setActiveTab('featured')}
          className={`px-4 py-2 text-md font-semibold ${
            activeTab === 'featured' ? 'border-b-2 border-gray-500 text-gray-500' : 'text-gray-700'
          }`}
        >
          Онцлох мэдээ
        </button>
        <button
          onClick={() => setActiveTab('new')}
          className={`px-4 py-2 text-md font-semibold ${
            activeTab === 'new' ? 'border-b-2 border-gray-500 text-gray-500' : 'text-gray-700'
          }`}
        >
          Шинэ мэдээ
        </button>
      </div>

    {activeTab === 'featured' && <NewsList path={'news/most-read/'} infinite={false} />}
    {activeTab === 'new' && <NewsList path={'news/most-recent/'} infinite={true} />}
    </div>
  );
};

export default TabbedNewsSection;
